import { h } from "preact";
import { useEffect, useState } from "preact/hooks";

import { request } from "../../api/request";
import { classNames } from "../../helpers";

export default function FreeText(props) {
  const [result, setResult] = useState(null);
  const [lastValue, setLastValue] = useState(null);

  async function recheck(value) {
    if (lastValue === value || props.hide) {
      return;
    }
    setLastValue(value);
    if (value) {
      const result = await request(props.endpoint, { value });
      setResult(result);
      props.onChange(result.valid);
    }
  }

  useEffect(() => {
    recheck(props.value);
  }, [props.value]);

  if (props.hide || !result || !props.value || !result.message) {
    return null;
  }

  return (
    <div
      class={classNames(
        "mb-16 inlineValidation",
        result.valid && "inlineValidation--success",
        !result.valid && "inlineValidation--failure",
        result.warning && "inlineValidation--warning",
        props.afterTextField && "inlineValidation--after-text-field"
      )}
    >
      {result.message}
    </div>
  );
}
